"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePosition = void 0;
function calculateTop(pos, box, display) {
    var top;
    var buffer = 10;
    switch (pos) {
        case 'top':
            top = -1 * (display.height + buffer) + display.contentOffsetY;
            break;
        case 'bottom':
            top = buffer + display.contentOffsetY + box.height;
            break;
        case 'start':
            top = display.contentOffsetY;
            break;
        case 'end':
            top = box.height - display.height + display.contentOffsetY;
            break;
        default:
            top = box.height / 2 - display.height / 2 + display.contentOffsetY;
            break;
    }
    return top;
}
function calculateLeft(just, box, display) {
    var left;
    var buffer = 10;
    switch (just) {
        case 'left':
            left = -1 * (display.width + buffer) + display.contentOffsetX;
            break;
        case 'right':
            left = box.width + buffer + display.contentOffsetX;
            break;
        case 'start':
            left = display.contentOffsetX;
            break;
        case 'end':
            left = box.width - display.width + display.contentOffsetX;
            break;
        default:
            left = box.width / 2 - display.width / 2 + display.contentOffsetX;
            break;
    }
    return left;
}
function calculateArrowPosition(justification, box) {
    var inset = 10;
    if (justification === 'start')
        return inset;
    if (justification === 'end')
        return box.height - inset;
    return box.height / 2;
}
function calculatePosition(direction, box, display) {
    var _a = direction.split('-'), position = _a[0], justification = _a[1];
    var vert = ['top', 'bottom'].includes(position) ? position : justification;
    var horz = ['left', 'right'].includes(position) ? position : justification;
    return {
        top: calculateTop(vert, box, display),
        left: calculateLeft(horz, box, display),
        arrowPosition: calculateArrowPosition(justification, box)
    };
}
exports.calculatePosition = calculatePosition;
